export default "__VITE_ASSET__DnP5iMvD__"